import { gql } from 'graphql-tag'

const monthlyInfoLinkFragment = gql`
  fragment MonthlyInfoLinkFragment on MonthlyInfoLinks {
    id
    fileName
    href
    type
    station {
      id
      name
    }
  }
`

export const addMonthlyInfoLink = gql`
  mutation AddMonthlyInfoLink($stationId: ID, $type: String!, $fileName: String!, $href: String!) {
    createMonthlyInfoLinks(stationId: $stationId, type: $type, fileName: $fileName, href: $href) {
      ...MonthlyInfoLinkFragment
    }
  }
  ${monthlyInfoLinkFragment}
`

export const deleteMonthlyInfoLink = gql`
  mutation DeleteMonthlyInfoLink($id: ID!) {
    deleteMonthlyInfoLinks(id: $id)
  }
`

export const fetchMonthlyInfoLinks = gql`
  query FetchMonthlyInfoLinks($stationId: ID!, $type: String!) {
    monthlyInfoLinks(stationId: $stationId, type: $type) {
      ...MonthlyInfoLinkFragment
    }
  }
  ${monthlyInfoLinkFragment}
`

export const fetchFileLinks = gql`
  query FetchFileLinks($companyId: ID!) {
    fileLinks {
      id
      fileName
      href
    }
    aokFileLinks(companyId: $companyId) {
      id
      fileName
      href
    }
  }
`
